module Meevo.Plugins.SwapGroups {
  "use strict";

  /**
  * SwapGroup Section of Client 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.SwapGroup> {
    /**
    * Base class override which defines what a DEFAULT model looks like.
    */
      isSwapServiceProductUnit: boolean;
      isUpgradeSwapServiceProductUnit: boolean;
      productUnitEnumType: Model.PackageServiceRedemptionEnum;
    createSectionModelInstance(postAdd:(data:any)=>any): void {
        this.dataService.getTemplate(this.baseEndpoint).then((data) => {
          this.model = data;
        });
      }
      activate(): void {
          super.activate();
          this.productUnitEnumType = Model.PackageServiceRedemptionEnum.ProductUnit;
          this.isSwapServiceProductUnit = this.model.swapServices.some(sr => sr.isProductUsageEnabled && sr.packageServiceRedemptionEnum == this.productUnitEnumType);
          this.isUpgradeSwapServiceProductUnit = this.model.upgradeSwapGroupServiceList.some(sr => sr.isProductUsageEnabled && sr.packageServiceRedemptionEnum == this.productUnitEnumType);        
      }
  }
}